import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-shivaji-maharaj-jayanti',
  templateUrl: './shivaji-maharaj-jayanti.component.html',
  styleUrls: ['./shivaji-maharaj-jayanti.component.scss']
})
export class ShivajiMaharajJayantiComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
